<template>

    <div class="row" v-if="crmgroup !== null">
        <div
            class="col-lg-offset-2 col-lg-4 col-sm-6"
            v-if="can('read','contacts')"
        >
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Contacten in groep {{ crmgroup.name }}</h2>
                    <div class="box-tools">
                        <connections
                            orig="crmgroup"
                            :orig-id="crmgroup.uuid"
                            target="contact"
                            :attach-url="route('api.v1.crm.groups.attach', {group_uuid:crmgroup.uuid})"
                            label="Contact koppelen"
                            eventOnCompleted="connectionAdded"
                            @connectionAdded="connectionAdded('contact')"
                        ></connections>
                    </div>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Naam</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="crmgroup.contacts.length === 0">
                                <td colspan="2">Er zijn geen contacten gekoppeld aan deze groep</td>
                            </tr>
                            <tr
                                v-for="contact in crmgroup.contacts"
                                :id="'row-' + contact.uuid"
                            >
                                <td>
                                    <router-link
                                        :to="{name:'crm.contacts.show', params:{uuid:contact.uuid}}"
                                    >
                                        {{ contact.fullname }}
                                    </router-link>
                                </td>
                                <td class="text-right">
                                    <delete-button
                                        :parent-element="'row-' + contact.uuid"
                                        :url="route('api.v1.crm.groups.detach', {group_uuid:crmgroup.uuid, target:'contact', target_uuid:contact.uuid})"
                                        title="Gekoppelde contact"
                                        :name="contact.fullname"
                                        class="btn-xs"
                                        v-tooltip="'Koppeling verwijderen'"
                                    ></delete-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div
            class="col-lg-4 col-sm-6"
            v-if="can('read','companies')"
        >
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">Bedrijven in groep {{ crmgroup.name }}</h2>
                    <div class="box-tools">
                        <connections
                            orig="crmgroup"
                            :orig-id="crmgroup.uuid"
                            target="company"
                            :attach-url="route('api.v1.crm.groups.attach', {group_uuid:crmgroup.uuid})"
                            label="Bedrijf koppelen"
                            eventOnCompleted="connectionAdded"
                            @connectionAdded="connectionAdded('company')"
                        ></connections>
                    </div>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Naam</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="crmgroup.companies.length === 0">
                                <td colspan="2">Er zijn geen bedrijven gekoppeld aan deze groep</td>
                            </tr>
                            <tr
                                v-for="company in crmgroup.companies"
                                :id="'row-' + company.uuid"
                            >
                                <td>
                                    <router-link
                                        :to="{name:'crm.companies.show', params:{uuid:company.uuid}}"
                                    >
                                        {{ company.name }}
                                    </router-link>
                                </td>
                                <td class="text-right">
                                    <delete-button
                                        :parent-element="'row-' + company.uuid"
                                        :url="route('api.v1.crm.groups.detach', {group_uuid:crmgroup.uuid, target:'company', target_uuid:company.uuid})"
                                        title="Gekoppeld bedrijf"
                                        :name="company.fullname"
                                        class="btn-xs"
                                        v-tooltip="'Koppeling verwijderen'"
                                    ></delete-button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import { mapGetters } from 'vuex';
import Connections from "../../../components/Common/Connections";

export default {

    components: {
        Connections,
    },

    computed: {

        ...mapGetters([
            'can',
            'getCrmGroups',
        ]),

        crmgroup() {
            if (!this.$route.params.uuid) {
                return null;
            }

            let crmgroup = this.getCrmGroups.filter(crmgroup => crmgroup.uuid === this.$route.params.uuid);

            return crmgroup.length !== 1 ?
                null :
                crmgroup[0];
        },

    },

    metaInfo: {
        title:'CRM groep bekijken',
    },

    methods: {
        connectionAdded(type) {
            this.$emit('updateCrmGroups');
            this.$snotify.success((type === 'company' ? 'Het bedrijf' : 'De contactpersoon') + ' is gekoppeld aan deze CRM groep');
        },
    },

    name:'CrmGroupsShow',

}

</script>
